export default "__VITE_ASSET__c18f77af__"